<template>

        <div  style="padding: 20px; height:850px; overflow: auto;padding-bottom:300px">
            <Tabs value="name1" @on-click="slitTag">
                <TabPane label="商品" name="name1">
                    <Form  inline  :label-width="60" >
                            <FormItem  label="商品名">
                                <Input type="text" v-model="searchs.goodsname" ></Input>
                            </FormItem>
                            <FormItem label="货号" >
                                <Input  type="text" v-model="searchs.goodscode" ></Input>
                            </FormItem>
                            <Button type="primary" @click="getGoodsByIsShow(page.page,page.rows)" >搜索</Button>
                    </Form>
                    <ul class="card">
                        <li v-for="(item,index) in goodsByIsShow" :key="index">
                            <Button :loading="loading" size="small" class="butn" type="success"  @click="open(item.id)">
                                <span v-if="!loading">启用</span>
                                <span v-else>启用中</span>
                            </Button>
                            <Fy-Img
                                    class="img"
                                    :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                            ></Fy-Img>
                             <h3>{{item.name}} ({{item.goodscode}})</h3>
                             <p style="padding: 6px 0">库存：{{item.num}}</p>
                            <Row>
                                <Col span="8"><Tag>零</Tag> ￥{{item.lprice}}</Col>
                                <Col span="8"><Tag>批</Tag> ￥{{item.pprice}}</Col>
                                <Col span="8"><Tag>采</Tag> ￥{{item.cprice}}</Col>
                            </Row>
                        </li>
                    </ul>
                </TabPane>
                <TabPane label="客户" name="name2">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="客户姓名">
                            <Input type="text" v-model="kh.name" ></Input>
                        </FormItem>
                        <FormItem label="手机号" >
                            <Input  type="text" v-model="kh.phone" ></Input>
                        </FormItem>
                        <Button type="primary"  @click="getAdminList(page.page,page.rows)"  >搜索</Button>
                    </Form>
                    <ul class="card">
                        <li style="padding: 20px 15px" v-for="(item,index) in customerList" :key="index">
                            <Button :loading="loading" size="small" class="butn" type="success"  @click="opencustomer(item.id)">
                                <span v-if="!loading">启用</span>
                                <span v-else>启用中</span>
                            </Button>
                            <Row>
                                <Col span="12">
                                    <h3>{{item.name}}</h3>
                                    <p  style="padding: 6px 0">{{item.phone}}</p>
                                    <p>{{item.membertime}}</p>
                                </Col>
                                <Col span="12">
                                    <p>客户余额</p>
                                    <strong>￥ {{item.money}}</strong>
                                    <p>会员卡余额</p>
                                    <strong>￥ {{item.pmoney}}</strong>
                                </Col>
                            </Row>
                        </li>
                    </ul>
                </TabPane>
                <TabPane label="供应商" name="name3">
                    <Form  inline  :label-width="100" >
                        <FormItem  label="供应商姓名">
                            <Input type="text" v-model="sup.name" ></Input>
                        </FormItem>
                        <FormItem label="手机号" >
                            <Input  type="text" v-model="sup.phone" ></Input>
                        </FormItem>
                        <Button type="primary"  @click="getSupplierList(page.page,page.rows)"  >搜索</Button>
                    </Form>
                    <ul class="card">
                        <li style="padding: 20px 15px" v-for="(item,index) in supplierList" :key="index">
                            <Button :loading="loading" size="small" class="butn" type="success"  @click="opensupplier(item.id)">
                                <span v-if="!loading">启用</span>
                                <span v-else>启用中</span>
                            </Button>
                            <Row>
                                <Col span="12">
                                    <h3>{{item.name}}</h3>
                                    <p  style="padding: 6px 0">负责人 {{item.username}}</p>
                                    <p>{{item.time}}</p>
                                </Col>
                                <Col span="12">
                                    <p>欠供应商款:</p>
                                    <strong>￥ {{item.beanmoney}}</strong>

                                </Col>
                            </Row>
                        </li>
                    </ul>
                </TabPane>
                <TabPane label="员工" name="name4">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="员工姓名">
                            <Input type="text" v-model="com.name" ></Input>
                        </FormItem>
                        <FormItem label="员工账号" >
                            <Input  type="text" v-model="com.phone" ></Input>
                        </FormItem>
                        <Button type="primary"  @click="getAdminList(page.page,page.rows)"  >搜索</Button>
                    </Form>
                    <ul class="card">
                        <li style="padding: 20px 15px" v-for="(item,index) in adminList" :key="index">
                            <Button :loading="loading" size="small" class="butn" type="success"  @click="openadmin(item.id)">
                                <span v-if="!loading">启用</span>
                                <span v-else>启用中</span>
                            </Button>
                            <Row>
                                <Col span="24">
                                    <h3>{{item.name}}</h3>
                                    <p  style="padding: 6px 0">所属门店: {{store}}</p>
                                    <p>员工账号: {{item.account}}</p>
                                </Col>
                            </Row>
                        </li>
                    </ul>
                </TabPane>
            </Tabs>
            <div class="pageTotal">
                <Page :total="page.total"
                      show-total
                      :page-size="page.rows"
                      :current="page.current"
                      @on-change="onGongPageTotal" />
            </div>
        </div>
</template>
<script>
    export default {
        components: {},
        data () {
            return {
                cid:"",
                sid:"",
                loading: false,
                store:'',
                page:{
                    total:1,
                    page:1,
                    current:1,
                    rows:12,
                },
                goodsByIsShow:[],//商品列表
                customerList:[],
                supplierList:[],
                adminList:[],
                tabname:"name1",
                searchs:{
                    goodsname:'',
                    goodscode:'',
                },
                sup:{
                    name:'',
                    phone:''
                },
                com:{
                    name:'',
                    phone:''
                },
                kh:{
                    name:'',
                    phone:'',
                },

            }
        },

        mounted: function() {
            //DOM更新完后再请求数据
            this.$nextTick(function() { });
        },
        created: function() {
            //DOM更新完之前请求数据
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.isCustomerSharing = JSON.parse(localStorage.getItem('shop')).isCustomerSharing
            this.getGoodsByIsShow(this.page.page,this.page.rows)
            this.getShopList()
        },

        watch: {
            'searchs.goodsname': {
                deep: true,
                handler: function (newVal,oldVal){
                    this.searchs.goodsname=newVal
                    this.getGoodsByIsShow(this.page.page,this.page.rows)
                }
            },
            'searchs.goodscode':{
                deep: true,
                handler: function (newVal,oldVal){
                    this.searchs.goodscode=newVal
                    this.getGoodsByIsShow(this.page.page,this.page.rows)
                }
            },
            /** 供应商 **/
            'sup.name':{
                deep: true,
                handler: function (newVal,oldVal){
                    this.sup.name=newVal
                    this.getSupplierList(this.page.page,this.page.rows)
                }
            },
            'sup.phone':{
                deep: true,
                handler: function (newVal,oldVal){
                    this.sup.phone=newVal
                    this.getSupplierList(this.page.page,this.page.rows)
                }
            },
            /** 客户 **/
            'com.name':{
                deep: true,
                handler: function (newVal,oldVal){
                    this.com.name=newVal
                    this.getAdminList(this.page.page,this.page.rows)
                }
            },
            'com.phone':{
                deep: true,
                handler: function (newVal,oldVal){
                    this.com.phone=newVal
                    this.getAdminList(this.page.page,this.page.rows)
                }
            },
            'kh.name':{
                deep: true,
                handler: function (newVal,oldVal){
                    this.kh.name=newVal
                    this.getCustomerList(this.page.page,this.page.rows)
                }
            },
            'kh.phone':{
                deep: true,
                handler: function (newVal,oldVal){
                    this.kh.phone=newVal
                    this.getCustomerList(this.page.page,this.page.rows)
                }
            },
        },


        methods: {
            /***
             * tab切换
             * ******/
            slitTag(num){
                this.tabname = num
                this.page.page=1
                this.page.rows=9
                this.page.current =1
                if(num=='name1'){
                    this.getGoodsByIsShow(this.page.page,this.page.rows)
                }else if(num=='name2'){
                    this.getCustomerList(this.page.page,this.page.rows)
                }else if(num=='name3'){
                    this.getSupplierList(this.page.page,this.page.rows)
                }else if(num=='name4'){
                    this.getAdminList(this.page.page,this.page.rows)
                }

            },

            //商品列表
            getGoodsByIsShow(page,rows){
                this.$Api.getGoodsByIsShow({
                    cid:this.cid,
                    sid:this.sid,
                    page:page,
                    rows:rows,
                    isShow:0,
                    name:this.searchs.goodsname,
                    goodscode:this.searchs.goodscode
                }).then(res => {
                    if(res.code==200){
                        this.page.total= res.count
                        this.goodsByIsShow=[]
                        this.goodsByIsShow=res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //客户列表
            getCustomerList(page,rows){
                this.$Api.getCustomerList({
                    cid:this.cid,
                    sid:this.sid,
                    page:page,
                    rows:rows,
                    isdel:0,
                    name:this.kh.name,
                    phone:this.kh.phone
                }).then(res => {
                    if(res.code==200){
                        this.page.total= res.count
                        this.customerList = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //供应商
            getSupplierList(page,rows){
                this.$Api.getSupplierList({
                    cid:this.cid,
                    sid:this.sid,
                    page:page,
                    rows:rows,
                    isdel:0,
                    name:this.sup.name,
                    phone:this.sup.phone
                }).then(res => {
                    if(res.code==200){
                        this.page.total= res.count
                        this.supplierList =  res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //获取业务员列表
            getAdminList(page,rows){
                this.$Api.getAdminList({
                    cid:this.cid,
                    sid:this.sid,
                    page:page,
                    rows:rows,
                    isdel:1,
                    name:this.com.name,
                    account:this.com.phone
                }).then(res => {
                    if(res.code==200){
                        this.page.total= res.count
                        this.adminList =  res.data
                        this.store=JSON.parse(localStorage.getItem('shop')).name
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            open(id){
                this.$Api.startUsingGoods({
                    id:id,
                    isShow: "1"
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success("已启用");
                        this.getGoodsByIsShow(1,this.page.rows)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            opencustomer(id){
                this.$Api.isdelCustomer({
                    id:id,
                    isdel: "1"
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success("已启用");
                        this.getCustomerList(1,this.page.rows)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            opensupplier(id){
                this.$Api.isdel({
                    id:id,
                    isdel: "1"
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success("已启用");
                        this. getSupplierList(1,this.page.rows)
                    }else {
                        this.$Message.warning(res.msg);
                    }

                });
            },
            /*员工*/
            openadmin(id){
                this.$Api.updateAdmin({
                    id:id,
                    isdel: "0"
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success("已启用");
                        this. getAdminList(1,this.page.rows)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            onGongPageTotal(num){
                if(this.tabname=="name1"){
                    this.getGoodsByIsShow(num,this.page.rows)
                }else if(this.tabname=="name2") {
                    this.getCustomerList(num,this.page.rows)
                }else if(this.tabname=="name3") {
                    this.getSupplierList(num,this.page.rows)
                }else if(this.tabname=="name4") {
                    this.getAdminList(num,this.page.rows)
                }
            },
        }
    }
</script>


<style  lang="scss" scoped>
     
    .card>li{
        width:380px;
        height:140px;
        background:rgba(255,255,255,1);
        border-radius:5px;
        box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.2);
        margin: 20px 30px;
        padding: 20px 15px 20px 130px;
        line-height: 26px;
        position: relative;
        float: left;
        position: relative;
        .img{
            position: absolute;
            top: 20px;
            left: 15px;
        }
        .butn{
            position: absolute;
            right: 0px;
            top: 0px;
        }
    }
   
</style>